export default "__VITE_ASSET__919e6689__"